import React from 'react';

const NotFound = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-light">
      <div className=" p-5 text-center" >
        <img
          src="/assets/img/notfound.png" // Replace with your own 404 image or illustration
          alt="404"
          className="img-fluid mb-4"
          style={{ maxHeight: '370px' }}
        />
        <h2 className="display-4 fw-bold text-primary">404</h2>
        <p className="fs-5 m-0 py-1 text-muted">Page you're looking for doesn't exist</p>
        <a href="/" className="btn btn-primary mt-2 px-4">Return</a>
      </div>
    </div>
  );
};

export default NotFound;
